import { createFileRoute } from '@tanstack/react-router';

import { WfCalendarDay } from '@/features/wireframes/clinic/calendar-day';

/**
 * Wireframe: Calendar day view.
 *
 * Static review page — fixtures only, no queries, no writes. Not linked from
 * anywhere in the product; delete it once the surface ships for real.
 */
export const Route = createFileRoute(
  '/_authed/dashboard/wireframes/calendar-day'
)({
  component: WfCalendarDay,
});
